import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(((_ctx.isMobileActive && _ctx.isMobileActive !== null) ? _ctx.getClass('errorMobile') : '') + ' ' +
_ctx.getClass('error'))
  }, [
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.getClass('errorMessage'))
    }, _toDisplayString(_ctx.errorMessage), 3 /* TEXT, CLASS */)
  ], 2 /* CLASS */))
}